import handleStatusCard from './handleStatusCard'

export default {
  handleStatusCard,
}
